<style src="./TracksUpload.scss" lang="scss"></style>

<template lang="pug">
  section.tracks-upload(
    :class='classList'
  )
    header.tracks-upload__header(
      v-if='title'
    )
      h3.tracks-upload__title {{ title }}
    .tracks-upload__body
      .tracks-upload__message(
        v-if='!filelist.length'
      ) {{ $l10n('TRACKLIST_IS_EMPTY') }}
      SortableList(
        v-else
        v-model="filelist"
        lockAxis="y"
        appendTo='.tracks-upload__drag'
        className='tracks-upload__list'
        :press-delay='300'
        @input='onSort'
      )
        SortableItem(
          v-for='(track, index) in filelist'
          v-if='track'
          className='tracks-upload__item'
          :index="index"
          :key='index'
          :disabled='sortDisabled'
        )
          Track(
            type='list'
            :track='track'
            :show-controls='false'
            :removable='true'
            :checkable='true'
            :checked='checked.includes(track.id)'
            :editable-title='true'
            :disable-link='true'
            @rename='rename(track)'
            @check='check(track.id, index)'
            @uncheck='uncheck(track.id, index)'
          )

      .tracks-upload__upload-area
        .tracks-upload__dropzone(
          v-show="$refs.upload && $refs.upload.dropActive"
        )
        .tracks-upload__field
          file-upload(
            name='tracks'
            ref='upload'
            :drop='true'
            :multiple='multiple'
            :custom-action='upload'
            @input-filter="inputFilter"
          )
        .tracks-upload__button(
          v-if='showButton'
        )
          Button(
            :label='$l10n("ADD_TRACK")'
            type='label'
            target='tracks'
            classList='is-small is-flat'
          )
        .tracks-upload__caption(
          v-if='showButton'
          v-html='$l10n("AVAILABLE_AUDIO_FORMATS")'
        )
    .tracks-upload__drag
</template>

<script>
import FileUpload from "vue-upload-component";
import Button from "@/components/Button/Button";
import Track from "@/components/Track/Track";
import SortableList from "@/components/SortableList/SortableList";
import SortableItem from "@/components/SortableList/SortableItem";

import {
  TRACKS_UPLOAD_TYPES_REGEXP,
  TRACK_UPLOAD_SIZE_LIMIT
} from "@/constants";

export default {
  props: {
    uploadHandler: {
      type: Function
    },
    title: {
      type: String,
      default: ""
    },
    multiple: {
      type: Boolean,
      default: true
    },
    tracksLimit: {
      type: Number,
      default: 30
    },
    tracks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      files: [],
      prevFilelist: [],
      filelist: [],
      checked: []
    };
  },
  computed: {
    classList() {
      return {
        "is-multiple": this.multiple,
        "has-button": this.showButton
      };
    },
    showButton() {
      return this.multiple
        ? this.tracks.length < this.tracksLimit
        : this.tracks.length < 1;
    },
    sortDisabled() {
      return this.filelist.length < 2;
    }
  },
  watch: {
    tracks() {
      this.prevFilelist = this.getFilelist();
      this.filelist = this.getFilelist();
    },
    files() {
      this.prevFilelist = this.getFilelist();
      this.filelist = this.getFilelist();
    }
  },
  components: {
    Track,
    FileUpload,
    Button,
    SortableList,
    SortableItem
  },
  methods: {
    getFilelist() {
      return [...this.tracks, ...this.files];
    },
    onSort() {
      this.$emit(
        "sort",
        this.filelist.map(track => track.id)
      );
    },
    rename(track) {
      this.$emit("track-rename", track);
    },
    check(id, index) {
      this.checked.push(id);
      this.$emit("checked", {
        id,
        action: "delete",
        index,
        checked: this.checked
      });
    },
    uncheck(id, index) {
      this.checked = this.checked.filter(item => item !== id);
      this.$emit("checked", {
        id,
        action: "restore",
        index,
        checked: this.checked
      });
    },
    inputFilter(newFile, oldFile, prevent) {
      this.$refs.upload.active = true;

      if (newFile && !oldFile) {
        if (!TRACKS_UPLOAD_TYPES_REGEXP.test(newFile.type)) {
          this.$error(this.$l10n("FILE_FORMAT_NOT_SUPPORT"));

          return prevent();
        }

        if (newFile.size > TRACK_UPLOAD_SIZE_LIMIT) {
          const size = TRACK_UPLOAD_SIZE_LIMIT / 1024 / 1024;

          this.$error(this.$l10n("FILE_SIZE_LARGE_THEN_LIMIT", { size }));

          return prevent();
        }
      }
    },
    async upload(entry) {
      const track = {
        file: entry.file,
        name: entry.name,
        progress: entry.progress
      };

      this.files = [...this.files, track];

      this.uploadHandler(track).then(() => {
        this.files = this.files.filter(file => file !== track);
      });
    }
  },
  created() {
    this.prevFilelist = this.getFilelist();
    this.filelist = this.getFilelist();
  }
};
</script>
